import React from 'react';
import Grid from "@material-ui/core/Grid";
import Tab from "@material-ui/core/Tab";
import Paper from "@material-ui/core/Paper";
import {useQuery} from "../../hooks/useQuery";
import MuiTabs from "@material-ui/core/Tabs";
import {useRedirect} from "../../hooks/useRedirect";
import {RouteNames} from "../../router/consts";

import {useParams} from "react-router-dom"
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useDialog } from '../../hooks/useDialog';
import { Dialog } from '../Dialog/Dialog';
import { useDispatch, useSelector } from 'react-redux';
import { changeActTemplate, getActTemplate, getActTemplateFieldLocal, getActTemplateFieldSearch, setActTemplateSearch } from '../../redux/reducers/act-template-reducer';
import { Button, Typography } from '@material-ui/core';
import { GridSaveAltIcon } from '@material-ui/data-grid';
import SaveIcon from '@material-ui/icons/Save';
import { GreenButton } from '../ActFilling/ActFillingFooter/ActFillingFooter';


const useStyles = makeStyles(() => ({
    tabs: {
        height: '100%',
    },
    contentArea: {
        flexGrow: 2
    }
}))



export const Tabs = ({tabs}) => {
    const classes = useStyles()

    const dispatch = useDispatch()

    const wordDialog = useDialog()

    const valuesLocal = useSelector(getActTemplateFieldLocal)
    const search = useSelector(getActTemplateFieldSearch)

    const {projectID} = useParams()    
    const query = useQuery()
    const {replace} = useRedirect()

    const handleTabClick = (event, newValue) => {
        if (currentValue === 'act-template') {
            wordDialog.handleOpen()
            dispatch(setActTemplateSearch(newValue))
        } else {
            replace(RouteNames.PROJECTS + `/${projectID}?tab=${newValue}`)
        }
     
    }

    const handleSave = () => {
        dispatch(changeActTemplate(valuesLocal))
        replace(RouteNames.PROJECTS + `/${projectID}?tab=${search}`)
        wordDialog.handleClose()
    }

    const DonthandleSave = () => {
        replace(RouteNames.PROJECTS + `/${projectID}?tab=${search}`)
        wordDialog.handleClose()
    }

    const currentValue = query.get('tab') || tabs[0]?.value

    return <Grid item container direction={'column'} xs className={classes.tabs} wrap={"nowrap"}>
        <Grid item>
            <MuiTabs value={currentValue} onChange={handleTabClick}>
                {tabs && tabs.map((tab, index) => <Tab key={`project-edit-tab-${index}`} value={tab.value} label={tab.label}/>)}
            </MuiTabs>
        </Grid>
        <Grid item className={classes.contentArea}>
            <Paper style={{height: '100%'}}>
                {tabs.find(f => f.value === currentValue).component}
            </Paper>
        </Grid>
        <Dialog
            open={wordDialog.open}
            title={'Несохраненные данные будут утеряны!!!'}
            handleClose={wordDialog.handleClose}
            fullWidth
            maxWidth={'sm'}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                }}
            >
                <Button
                    onClick={DonthandleSave}
                >
                    Не сохранять
                </Button>
                <GreenButton
                    children={<></>}
                    onClick={handleSave}
                >
                    Сохранить данные
                </GreenButton>
            </div>
            
        </Dialog>
    </Grid>
}